

import { Toast } from 'vant'

export function getOpenId(getOpenIdFn) {

} 

/**
 * 校验当前浏览器环境是否是微信内置浏览器
 * @returns 是否是微信内置浏览器拉起 true： 微信内置浏览器， false： 非微信浏览器
 */
export function checkWeChatBrowser() {
  return /MicroMessenger/i.test((navigator && navigator.userAgent) || '')
}

/**
 * 刷新当前页面，携带code回来，以便查询openId
 * @param {object} param {appid, url} 
 * 注： appid为支付应用号； url为重定向页面，一般为当前页面，由于微信redirect_uri授权路径规则不支持哈希路由，注意传入路径
 * 
 */
export function refreshNoOpenIdPage({appid, url}) {
  const redirectUrl =
  `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid
  }&redirect_uri=${url
  }&response_type=${'code'
  }&scope=${'snsapi_base'
  }&state=${'cashier'
  }#wechat_redirect`
  // demo：'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx336439508d336e22&redirect_uri=http%3A%2F%2Fbaoh5test.turingsenseai.com%2Fwxredirect%2Findex.html%3Frefer%3Dhttps%253A%252F%252Fbaoh5test.turingsenseai.com%252Fh5%252F%2523%252Fcashier%253ForderNumber%253DEA202012041404366884%2526orderType%253D3&response_type=code&scope=snsapi_base&state=#wechat_redirect'
  // https://baoh5test.turingsenseai.com/wxredirect/index.html?refer=https%3A%2F%2Fbaoh5test.turingsenseai.com%2Fh5%2F%23%2Fcashier%3ForderNumber%3DEA202012041404366884%26orderType%3D3&code=051cNlFa1AP16A0IIDFa1FJXDC0cNlFz&state=
  setTimeout(() => {
    window.location.replace(redirectUrl)
  }, 100)
}

/**
 * 建立或监听微信桥接
 * @param {object} param { invokeParams, _callback, _payCallBack } 
 * 注 invokeParams: 触发微信内支付的参数
 *    _callback: 微信桥通讯成功回调
 *    _payCallBack: 支付回调
 */
export function dealJSBridgeEvent({invokeParams = {}, _callback = bridgeReadyCallBack, payCallback}) {
  if (typeof window.WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady',() => _callback(invokeParams, payCallback), false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', () => _callback(invokeParams, payCallback))
      document.attachEvent('onWeixinJSBridgeReady', () => _callback(invokeParams, payCallback))
    }
  } else {
    _callback(invokeParams, payCallback)
  }
}

/**
 * 调起微信支付
 * @param {object} param0 微信支付调用参数，参数字段请严格按照如下方式
 * @param {function} payCallback 支付回调函数
 */
export function bridgeReadyCallBack({appId, timestamp: timeStamp, nonceStr, package: __package, signType, paySign }, payCallback = payCallBack) {
  window.WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    {
      appId, //公众号名称，由商户传入
      timeStamp, //时间戳，自1970年以来的秒数
      nonceStr, //随机串
      package: __package,
      signType, //微信签名方式：
      paySign //微信签名
    },
    payCallback
  )
}

/**
 * 处理支付回调结果
 * @param {object} res 回调结果信息
 */
export function payCallBack(res) {
  if (res.err_msg === 'get_brand_wcpay_request:ok') {
    Toast('支付成功')
  } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
    Toast('取消支付')
  } else {
    Toast('支付失败')
  }
}